import { WET_WALL_ASSETS } from "./wetWallAssets";

const blackSet = WET_WALL_ASSETS["black-sensation"];
const whiteSet = WET_WALL_ASSETS["white-sparkle"];
const retroSet = WET_WALL_ASSETS["retro-grey"];
const greySet = WET_WALL_ASSETS["grey-marble"];
const carraraSet = WET_WALL_ASSETS["carrara-marble"];
const stoneSet = WET_WALL_ASSETS["stone-beige"];


import wwInternalCornerImg from "@/assets/products/ww-internal-corner.png";
import wwInternalCornerPhoto from "@/assets/products/ww-internal-corner-photo.jpg";
import wwExternalCornerImg from "@/assets/products/ww-external-corner.png";
import wwExternalCornerPhoto from "@/assets/products/ww-external-corner-photo.jpg";
import wwStartCapImg from "@/assets/products/ww-start-cap.png";
import wwStartCapPhoto from "@/assets/products/ww-start-cap-photo.jpg";
import wwHJoiningImg from "@/assets/products/ww-h-joining.png";
import wwHJoiningPhoto from "@/assets/products/ww-h-joining-photo.jpg";
import wwLShapeImg from "@/assets/products/ww-l-shape.png";
import wwLShapePhoto from "@/assets/products/ww-l-shape-photo.jpg";
import wwAdhesiveGlueAsset from "@/assets/products/supreme-turf-premium-neutral-silicone-sealant.webp.asset.json";

const wwAdhesiveGlue = wwAdhesiveGlueAsset.url;

export interface PVCWetWallProduct {
  id: string;
  name: string;
  price: number;
  priceUnit: string;
  image: string;
  images: string[];
  description: string;
  colour: string;
  shopifyVariantId: string;
}

// Gallery images for the animated marquee
export const WET_WALL_GALLERY_IMAGES = [blackSet, carraraSet, greySet, retroSet, stoneSet, whiteSet]
  .flatMap((set) =>
    set.installations.map((src, i) => ({
      src,
      alt: set.alts[i + 1] ?? `${set.productName} from Supreme Turf`,
    })),
  );


export interface WetWallAccessory {
  id: string;
  name: string;
  description: string;
  price: number;
  priceUnit: string;
  size: string;
  colours: string[];
  image: string;
  images: string[];
  shopifyVariantId?: string;
}

export const WET_WALL_ACCESSORIES: WetWallAccessory[] = [
  {
    id: "ww-internal-corner",
    name: "Internal Corner",
    description: "Internal corner trim for seamless inside corner finishing on Supreme Wet Wall panels.",
    price: 10,
    priceUnit: "each",
    size: "2500mm length",
    colours: ["Natural White", "Quartz Grey", "Graphite Black"],
    image: wwInternalCornerImg,
    images: [wwInternalCornerImg, wwInternalCornerPhoto],
    shopifyVariantId: "gid://shopify/ProductVariant/47826820694257",
  },
  {
    id: "ww-external-corner",
    name: "External Corner",
    description: "External corner trim for clean outside corner transitions on Supreme Wet Wall panels.",
    price: 10,
    priceUnit: "each",
    size: "2500mm length",
    colours: ["Natural White", "Quartz Grey", "Graphite Black"],
    image: wwExternalCornerImg,
    images: [wwExternalCornerImg, wwExternalCornerPhoto],
    shopifyVariantId: "gid://shopify/ProductVariant/47826820727025",
  },
  {
    id: "ww-start-cap",
    name: "Start Cap",
    description: "Start cap trim for neat edge finishing on Supreme Wet Wall panel installations.",
    price: 10,
    priceUnit: "each",
    size: "2500mm length",
    colours: ["Natural White", "Quartz Grey", "Graphite Black"],
    image: wwStartCapImg,
    images: [wwStartCapImg, wwStartCapPhoto],
    shopifyVariantId: "gid://shopify/ProductVariant/47826820759793",
  },
  {
    id: "ww-h-joining-trim",
    name: "H Joining Trim",
    description: "H joining trim for connecting two Supreme Wet Wall panels with a seamless joint.",
    price: 10,
    priceUnit: "each",
    size: "2500mm length",
    colours: ["Natural White", "Quartz Grey", "Graphite Black"],
    image: wwHJoiningImg,
    images: [wwHJoiningImg, wwHJoiningPhoto],
    shopifyVariantId: "gid://shopify/ProductVariant/47826820923633",
  },
  {
    id: "ww-l-shape-trim",
    name: "L Shape Trim",
    description: "L shape trim for clean edge finishing on Supreme Wet Wall panel installations.",
    price: 10,
    priceUnit: "each",
    size: "2500mm length",
    colours: ["Natural White", "Quartz Grey", "Graphite Black"],
    image: wwLShapeImg,
    images: [wwLShapeImg, wwLShapePhoto],
    shopifyVariantId: "gid://shopify/ProductVariant/47826820956401",
  },
  {
    id: "ww-adhesive-glue",
    name: "Panel Adhesive Glue",
    description: "High-strength waterproof adhesive specially formulated for Supreme Wet Wall panel installation.",
    price: 10,
    priceUnit: "each",
    size: "310ml cartridge",
    colours: [],
    image: wwAdhesiveGlue,
    images: [wwAdhesiveGlue],
    shopifyVariantId: "gid://shopify/ProductVariant/47826820989169",
  },
];

export const PVC_WET_WALL_PRODUCTS: PVCWetWallProduct[] = [
  {
    id: "black-sensation",
    name: "Black Sensation Supreme Wet Wall Panel",
    price: 100,
    priceUnit: "panel",
    image: blackSet.primary,
    images: blackSet.images,
    colour: "Black Sensation",
    shopifyVariantId: "gid://shopify/ProductVariant/47826571297009",
    description: "Make a statement that lasts with Black Sensation Wet Wall Panels — where bold design meets effortless luxury. Inspired by the striking beauty of real black marble, these panels instantly elevate your bathroom into a sleek, designer-led space. Go dramatic with deep, moody tones or create show-stopping contrast with light finishes — either way, the impact is undeniable.\n\nPrecision tongue-and-groove joints deliver a flawless, near-seamless finish that looks custom-installed. Crafted from premium waterproof PVC, Black Sensation Wall Panels are built for performance in bathrooms, showers, wet rooms, and stylish splashbacks throughout your home.\n\nNo grout. No mould. No maintenance headaches. Their moisture-resistant surface protects your walls and wipes clean in seconds, keeping your space looking pristine day after day.\n\nLuxury looks. Smart design. Zero compromise.",
  },
  {
    id: "white-sparkle",
    name: "White Sparkle Supreme Wet Wall Panel",
    price: 100,
    priceUnit: "panel",
    image: whiteSet.primary,
    images: whiteSet.images,
    colour: "White Sparkle",
    shopifyVariantId: "gid://shopify/ProductVariant/47826571395313",
    description: "Elevate your space with White Sparkle Wall Panels — where crisp white tones meet soft grey accents and a subtle touch of shimmer. Designed to reflect light beautifully, this refined finish adds depth and elegance without overpowering your space — perfect for those who love understated luxury.\n\nFeaturing a fine-grained white base infused with ultra-fine mirror chips, White Sparkle captures the move towards minimal, sophisticated surfaces. The delicate sparkle comes to life under lighting, making it ideal for statement walls, splashbacks, kitchens, bathrooms, and stylish commercial interiors.\n\nDurable and versatile, these panels are built for both interior and exterior applications, including outdoor kitchens. Whether used in homes or commercial spaces, White Sparkle delivers a polished, modern look with long-lasting performance.\n\nClean. Contemporary. Subtly striking.",
  },
  {
    id: "retro-grey",
    name: "Retro Grey Supreme Wet Wall Panel",
    price: 100,
    priceUnit: "panel",
    image: retroSet.primary,
    images: retroSet.images,
    colour: "Retro Grey",
    shopifyVariantId: "gid://shopify/ProductVariant/47826571428081",
    description: "Introduce calm, contemporary style with our Retro Grey Wall Panels — the perfect balance of warmth, texture, and retro design. Featuring on-trend grey tones and a realistic concrete effect, these panels bring an effortlessly cool, architectural feel to your bathroom or wet space.\n\nInspired by natural concrete, this design creates a refined, minimalist look that feels both modern and inviting. Fully waterproof and beautifully understated, Retro Grey Wall Panels are ideal for showers and bathrooms where subtle sophistication makes a powerful statement.\n\nCrafted from premium-quality PVC, the panels lock together using precision tongue-and-groove technology to deliver a smooth, near-seamless finish. The matte surface adds to the authentic concrete look while remaining incredibly practical — simply wipe clean to keep your space looking fresh and polished.\n\nModern texture. Seamless finish. Effortless upkeep.",
  },
  {
    id: "grey-marble",
    name: "Grey Marble Supreme Wet Wall Panel",
    price: 100,
    priceUnit: "panel",
    image: greySet.primary,
    images: greySet.images,
    colour: "Grey Marble",
    shopifyVariantId: "gid://shopify/ProductVariant/47826571493617",
    description: "Create a sleek, sophisticated bathroom with our Grey Marble Wall Panels — the perfect way to elevate your space with effortless Italian-inspired luxury. Striking grey veining and soft, warm shadows flow across a creamy white base, delivering a bold marble look that feels refined, modern, and undeniably premium.\n\nDesigned for wet areas, these panels feature a fully waterproof, mould-resistant surface that protects your walls while maintaining a flawless finish. Crafted from high-quality PVC, they're built to last and incredibly easy to maintain — a simple wipe with a damp cloth keeps them looking pristine.\n\nGet the luxurious marble aesthetic without the cost, complexity, or maintenance of real stone. Our Grey Marble Wet Wall Panels are a smart, budget-friendly alternative that installs quickly and easily, even directly over existing walls. No grout, no mess, and no downtime — just instant transformation that saves you time and money.\n\nPremium marble style. Practical performance. Smart value.",
  },
  {
    id: "carrara-marble",
    name: "Carrara Marble Supreme Wet Wall Panel",
    price: 100,
    priceUnit: "panel",
    image: carraraSet.primary,
    images: carraraSet.images,
    colour: "Carrara Marble",
    shopifyVariantId: "gid://shopify/ProductVariant/47826571526385",
    description: "Elevate your space with the timeless beauty of Carrara Marble Wall Panels — a refined take on one of the world's most iconic marbles. Featuring crisp white tones and elegant grey veining, this design floods your bathroom or shower with light while delivering a truly high-end, designer finish.\n\nEnjoy the classic Carrara marble look without the cost, upkeep, or complications of natural stone. Crafted with a smooth, premium-quality surface, these panels are fully waterproof, highly durable, and effortlessly easy to maintain. No sealing. No grout. No stress. Just wipe clean and enjoy flawless walls every day.\n\nInstallation is fast, simple, and DIY-friendly. Thanks to the precision tongue-and-groove locking system, panels fit together seamlessly for a sleek, watertight finish with minimal visible joins — no specialist tools required.\n\nPerfect for creating a calm, hotel-inspired retreat, Carrara Marble Wall Panels deliver timeless elegance with modern performance, making them a smart and stylish choice for both contemporary and classic interiors.\n\nClassic luxury. Modern living. Effortless beauty.",
  },
  {
    id: "stone-beige",
    name: "Stone Beige Supreme Wet Wall Panel",
    price: 100,
    priceUnit: "panel",
    image: stoneSet.primary,
    images: stoneSet.images,
    colour: "Stone Beige",
    shopifyVariantId: "gid://shopify/ProductVariant/47826571591921",
    description: "Inspired by the refined beauty of natural marble from the historic Turkish city, our Stone Beige Wall Panels bring effortless elegance and serenity to bathrooms, laundries, and wet areas. Soft, light tones create a bright, calming space while delivering a timeless marble look that complements both classic and contemporary interiors.\n\nDesigned for modern living, these panels feature precision tongue-and-groove technology that locks together seamlessly to form a smooth, fully waterproof finish. They can be installed directly onto new or existing walls, making upgrades faster, cleaner, and far more cost-effective than traditional tiles or marble.\n\nCrafted from premium-quality PVC, Stone Beige Wall Panels are built for durability and everyday practicality. The smooth, wipe-clean surface keeps your walls looking immaculate with minimal maintenance — no grout, no sealing, no stress.\n\nTimeless marble style. Seamless installation. Effortless luxury.",
  },
];
